export const blockIconsSearchLiving = (
	<span className='material-symbols-outlined'>living</span>
);
